import { css } from '../../../styles/theme';

export const StylesAP = css`
    .noLinkButton {
        &:hover {
            background: ${({ theme }) => theme.colors.white};
            color: ${({ theme }) => theme.colors.primary};
            border-color: ${({ theme }) => theme.colors.primary};
        }
    }
`;
